import React from "react";
import { ArrowUpTrayIcon, UserCircleIcon } from "@heroicons/react/24/outline";

/**
 * Foto (archivo) + descripción de especialidad para flujos de admin o psicólogo.
 * El título de la sección lo pone el contenedor padre.
 */
export default function PsychologistPhotoSpecialtyBlock({
  profileImageUrl,
  localPreviewUrl,
  specialtyDescription,
  onSpecialtyChange,
  onFileChange,
  uploadingPhoto = false,
  disabled = false,
  idPrefix = "psych",
}) {
  const showImg = profileImageUrl || localPreviewUrl;
  const inputId = `${idPrefix}-photo-file`;

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-4">
        <div className="shrink-0">
          {showImg ? (
            <img
              src={localPreviewUrl || profileImageUrl}
              alt=""
              className="h-20 w-20 rounded-2xl object-cover border border-brand-brown/15 bg-slate-100"
            />
          ) : (
            <div className="flex h-20 w-20 items-center justify-center rounded-2xl border border-dashed border-brand-brown/25 bg-brand-lilac/20 text-brand-gray">
              <UserCircleIcon className="h-10 w-10" aria-hidden />
            </div>
          )}
        </div>
        <div className="min-w-0 flex-1">
          <input
            id={inputId}
            type="file"
            accept="image/jpeg,image/png,image/webp"
            className="sr-only"
            disabled={disabled || uploadingPhoto}
            onChange={onFileChange}
          />
          <label
            htmlFor={inputId}
            className={`inline-flex items-center gap-2 rounded-xl border border-brand-lavender/40 bg-brand-lilac/25 px-3.5 py-2 text-[0.9375rem] font-semibold text-brand-navy transition-colors hover:bg-brand-lilac/45 ${
              disabled || uploadingPhoto ? "cursor-not-allowed opacity-60" : "cursor-pointer"
            }`}
          >
            <ArrowUpTrayIcon className="h-4 w-4" aria-hidden />
            {uploadingPhoto
              ? "Subiendo…"
              : showImg
                ? "Cambiar foto"
                : "Seleccionar foto"}
          </label>
          <p className="portal-meta mt-1.5">JPG, PNG o WebP · máx. 5 MB</p>
        </div>
      </div>
      <div className="space-y-1.5">
        <label className="portal-label">
          Especialidad o enfoque{" "}
          <span className="font-normal text-brand-gray">(visible al agendar)</span>
        </label>
        <textarea
          rows={4}
          value={specialtyDescription}
          onChange={(e) => onSpecialtyChange(e.target.value)}
          disabled={disabled}
          placeholder="Ej. Ansiedad, depresión, adolescentes…"
          className="w-full rounded-xl border border-blue-gray-200 bg-white px-3.5 py-2.5 text-[0.9375rem] text-brand-dark placeholder:text-brand-gray/60 focus:border-brand-lavender focus:outline-none focus:ring-2 focus:ring-brand-lavender/20 disabled:opacity-60 resize-none transition-colors"
        />
      </div>
    </div>
  );
}
